var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-content",style:({ backgroundImage:_vm.loginBg?("url(" + _vm.loginBg + ")"):("url(" + _vm.bg + ")")})},[_c('alogin2')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }